import { SvgIconProps } from 'ui/icons/SvgIcon';

export const WorkflowsEmptyState = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M12.7749 72.1741C12.7749 78.8978 14.0992 85.5556 16.6723 91.7675C19.2453 97.9794 23.0167 103.624 27.771 108.378C32.5254 113.132 38.1696 116.904 44.3815 119.477C50.5934 122.05 57.2512 123.374 63.9749 123.374C70.6986 123.374 77.3564 122.05 83.5683 119.477C89.7802 116.904 95.4244 113.132 100.179 108.378C104.933 103.624 108.704 97.9794 111.278 91.7675C113.851 85.5556 115.175 78.8978 115.175 72.1741C115.175 65.4504 113.851 58.7926 111.278 52.5807C108.704 46.3689 104.933 40.7246 100.179 35.9703C95.4244 31.2159 89.7802 27.4445 83.5683 24.8715C77.3564 22.2984 70.6986 20.9741 63.9749 20.9741C57.2512 20.9741 50.5934 22.2984 44.3815 24.8715C38.1696 27.4445 32.5254 31.2159 27.771 35.9703C23.0167 40.7246 19.2453 46.3689 16.6723 52.5807C14.0992 58.7926 12.7749 65.4504 12.7749 72.1741Z"
        fill="#F5F4F4"
      />
      <path
        d="M48.4946 110.894C48.4946 111.403 49.9781 111.892 52.6186 112.252C55.2591 112.612 58.8404 112.814 62.5746 112.814C66.3089 112.814 69.8902 112.612 72.5307 112.252C75.1712 111.892 76.6546 111.403 76.6546 110.894C76.6546 110.385 75.1712 109.897 72.5307 109.536C69.8902 109.176 66.3089 108.974 62.5746 108.974C58.8404 108.974 55.2591 109.176 52.6186 109.536C49.9781 109.897 48.4946 110.385 48.4946 110.894Z"
        fill="#E0DEDF"
      />
      <path
        d="M34.4507 100.752C34.452 101.256 34.6533 101.739 35.0104 102.096C35.3675 102.452 35.8513 102.652 36.3557 102.652H91.5937C92.0981 102.652 92.5818 102.452 92.939 102.096C93.2961 101.739 93.4974 101.256 93.4987 100.752V35.9033L80.102 22.6519L36.3557 22.6519C35.8513 22.6519 35.3675 22.8519 35.0104 23.208C34.6533 23.5642 34.452 24.0475 34.4507 24.5519V100.752Z"
        fill="#FDF5FF"
        stroke="#622C6A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M93.4988 35.934H81.6753C81.2887 35.9329 80.9182 35.7789 80.6448 35.5056C80.3713 35.2323 80.2171 34.8619 80.2158 34.4753V22.6519L93.4988 35.934Z"
        stroke="#622C6A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.6162 39.8007C51.6162 38.5576 52.624 37.5498 53.8672 37.5498H73.9614C75.2045 37.5498 76.2123 38.5576 76.2123 39.8008V47.0094C76.2123 48.2526 75.2045 49.2604 73.9614 49.2604H53.8672C52.624 49.2604 51.6162 48.2526 51.6162 47.0094V39.8007Z"
        fill="white"
        stroke="#622C6A"
        strokeWidth="1.12547"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.877 85.2104C54.877 83.9673 55.8847 82.9595 57.1279 82.9595H70.7022C71.9454 82.9595 72.9532 83.9673 72.9532 85.2104V92.4191C72.9532 93.6622 71.9454 94.67 70.7022 94.67H57.1279C55.8847 94.67 54.877 93.6622 54.877 92.4191V85.2104Z"
        fill="white"
        stroke="#622C6A"
        strokeWidth="1.12547"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.3184 66.8696C39.3184 65.6264 40.3261 64.6187 41.5693 64.6187H55.8201C57.0632 64.6187 58.071 65.6264 58.071 66.8696V74.0783C58.071 75.3214 57.0632 76.3292 55.8201 76.3292H41.5693C40.3261 76.3292 39.3184 75.3214 39.3184 74.0783V66.8696Z"
        fill="white"
        stroke="#622C6A"
        strokeWidth="1.12547"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M70.8394 66.8696C70.8394 65.6264 71.8471 64.6187 73.0903 64.6187H87.3411C88.5842 64.6187 89.592 65.6264 89.592 66.8696V74.0783C89.592 75.3214 88.5842 76.3292 87.3411 76.3292H73.0903C71.8471 76.3292 70.8394 75.3214 70.8394 74.0783V66.8696Z"
        fill="white"
        stroke="#622C6A"
        strokeWidth="1.12547"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.2051 49.2603V82.9592"
        stroke="#622C6A"
        strokeWidth="1.12547"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80.2147 64.6188V55.5059H47.6143V64.6188"
        stroke="#622C6A"
        strokeWidth="1.12547"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="54.1533" y="40.1748" width="6.46055" height="6.46055" rx="1.12547" fill="#CAF3E7" />
      <rect x="42.2339" y="67.2437" width="6.46055" height="6.46055" rx="1.12547" fill="#C2F0FC" />
      <rect x="73.7539" y="67.2437" width="6.46055" height="6.46055" rx="1.12547" fill="#C2F0FC" />
      <rect x="57.4541" y="85.584" width="6.46055" height="6.46055" rx="1.12547" fill="#FAECAD" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="128" height="128" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
